/* eslint-disable import/prefer-default-export */

export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const SET_LOCALE_START = 'SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';

// order action type
export const SET_IS_TOGGLE_ON = 'SET_IS_TOGGLE_ON';

// Login action type
export const LOGIN = 'LOGIN';
export const IS_EXPIRED_LOGIN = 'IS_EXPIRED_LOGIN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const REGISTER = 'REGISTER';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES =
  'SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES';
export const SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES =
  'SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES';

// Quoting
export const QUOTING_GOOGLE_MAP = 'QUOTING_GOOGLE_MAP';
export const QUOTING_ADDRESS_1 = 'QUOTING_ADDRESS_1';
export const QUOTING_ADDRESS_2 = 'QUOTING_ADDRESS_2';
export const QUOTING_PRICE_VAN = 'QUOTING_PRICE_VAN';
export const QUOTING_SET_VEHICLE_PRICE = 'QUOTING_SET_VEHICLE_PRICE';
export const QUOTING_PRICE_5TON = 'QUOTING_PRICE_5TON';
export const QUOTING_PRICE_9TON = 'QUOTING_PRICE_9TON';
export const QUOTING_IS_GET_QUOTE = 'QUOTING_IS_GET_QUOTE';
export const QUOTING_SELECTED_VEHICLE = 'QUOTING_SELECTED_VEHICLE';
export const IS_DRAGGING_MAP = 'IS_DRAGGING_MAP';
export const QUOTING_IS_NO_SERVICE = 'QUOTING_IS_NO_SERVICE';
// Order
export const ORDER_VEHICLE_TYPE = 'ORDER_VEHICLE_TYPE';
export const ORDER_PASSENGER_COURT = 'ORDER_PASSENGER_COURT';
export const ORDER_TUNNEL = 'ORDER_TUNNEL';
export const ORDER_PICKUP_TIME = 'ORDER_PICKUP_TIME';
export const ORDER_NEED_OVER_6FT = 'ORDER_NEED_OVER_6FT';
export const ORDER_REMOVE_NET = 'ORDER_REMOVE_NET';
export const ORDER_NEED_CART = 'ORDER_NEED_CART';
export const ORDER_CART_COUNT = 'ORDER_CART_COUNT';
export const ORDER_NEED_CARRY = 'ORDER_NEED_CARRY';
export const ORDER_NEED_NEW_CAR = 'ORDER_NEED_NEW_CAR';
export const ORDER_NEED_PET = 'ORDER_NEED_PET';
export const ORDER_NEED_WASTE = 'ORDER_NEED_WASTE';
export const ORDER_PAY_BY_RECEIVER = 'ORDER_PAY_BY_RECEIVER';
export const ORDER_ADD_ADDRESS = 'ORDER_ADD_ADDRESS';
export const ORDER_UPDATE_ADDRESS = 'ORDER_UPDATE_ADDRESS';
export const ORDER_ADD_IMAGE = 'ORDER_ADD_IMAGE'; // add img and ready to upload to server
export const ORDER_UPDATE_IMAGE = 'ORDER_UPDATE_IMAGE';
export const ORDER_REMOVE_IMAGE = 'ORDER_REMOVE_IMAGE';
export const ORDER_ID_DETAIL = 'ORDER_ID_DETAIL';
export const ORDER_PRICE_BREAKDOWN_DETAIL = 'ORDER_PRICE_BREAKDOWN_DETAIL';
export const ORDER_COUPON = 'ORDER_COUPON';
export const ORDER_REMARK = 'ORDER_REMARK';
export const IS_CLICK_CONFIRM_ORDER = 'IS_CLICK_CONFIRM_ORDER'; // confirm order and plan to preview order
export const IS_VALID_ORDER = 'IS_VALID_ORDER'; // checking whether order is valid
export const ADD_UPLOADED_ORDER_IMAGE = 'ADD_UPLOADED_ORDER_IMAGE'; // Uploaded img to server and get response
export const IS_SHOW_COUPON = 'IS_SHOW_COUPON';
export const IS_UPLOADED_CLIENT_PHOTO = 'IS_UPLOADED_CLIENT_PHOTO'; // check whether finish uploaded client photo
// Order Detail Info
export const INIT_ORDER_DETAIL_INFO = 'INIT_ORDER_DETAIL_INFO';
export const UPDATE_ORDER_DETAIL_INFO = 'UPDATE_ORDER_DETAIL_INFO';
export const ADD_ORDER_DETAIL_INFO = 'ADD_ORDER_DETAIL_INFO';
export const REMOVE_ORDER_DETAIL_INFO = 'REMOVE_ORDER_DETAIL_INFO';

// show popup modal in header for login/register/update user info
export const IS_SHOW_LOGIN_MODAL = 'IS_SHOW_LOGIN_MODAL';
export const IS_SHOW_REGISTER_MODAL = 'IS_SHOW_REGISTER_MODAL';
export const IS_SHOW_UPDATE_USER_MODAL = 'IS_SHOW_UPDATE_USER_MODAL';

// dialog
export const IS_SHOW_CANCEL_ORDER_DIALOG = 'IS_SHOW_CANCEL_ORDER_DIALOG';
export const IS_SHOW_CANCEL_ORDER_DIALOG_ALERT =
  'IS_SHOW_CANCEL_ORDER_DIALOG_ALERT';

export const IS_SHOW_STAR_DIALOG = 'IS_SHOW_STAR_DIALOG';
export const IS_SHOW_BLACKLIST_DIALOG = 'IS_SHOW_BLACKLIST_DIALOG';
export const IS_SHOW_REPORT_ISSUE_DIALOG = 'IS_SHOW_REPORT_ISSUE_DIALOG';
export const IS_SHOW_BONUS_PRICE_DIALOG = 'IS_SHOW_BONUS_PRICE_DIALOG';
export const IS_SHOW_EXTRA_MESSAGE_DIALOG = 'IS_SHOW_EXTRA_MESSAGE_DIALOG';
export const IS_SHOW_SMS_PHONE_DIALOG = 'IS_SHOW_SMS_PHONE_DIALOG';
export const IS_SHOW_SMS_VERIFY_DIALOG = 'IS_SHOW_SMS_VERIFY_DIALOG';
export const IS_SHOW_SMS_VERIFY_LOADING_DIALOG =
  'IS_SHOW_SMS_VERIFY_LOADING_DIALOG';
export const IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG =
  'IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG';
export const IS_SHOW_SIMPLE_MESSAGE_DIALOG = 'IS_SHOW_SIMPLE_MESSAGE_DIALOG';
export const SET_SIMPLE_MESSAGE = 'SET_SIMPLE_MESSAGE';
export const IS_SHOW_AGREE_TO_RECEIVER_DIALOG =
  'IS_SHOW_AGREE_TO_RECEIVER_DIALOG';
// driver
export const SET_DRIVER_BLACKLIST = 'SET_DRIVER_BLACKLIST';

// SMS
export const IS_SENDING_SMS = 'IS_SENDING_SMS';

// Ensure current website lang is default lang
export const IS_DEFAULT_LANG = 'IS_DEFAULT_LANG';



// WEBPACK FOOTER //
// ./src/constants/index.js